import { V2Networks } from '@shared/utils/config/networkAddresses';
import { ChainId } from '@shared/utils/config/networks';
import { ethers } from 'ethers';
import { isEVMNetwork } from '@shared/utils/validation/network-validation';
import { isNativeTokenAddress } from '../asset/nativeAddressHelper';
export const fallbackLogo = '/static/geniusImages/network_logos/baseFallbackToken.png';
export const getTokenImageFromAssetItem = assetItem => {
  var _a, _b, _c, _d, _e, _f, _g;
  return isNativeTokenAddress(assetItem.contract_address) ? getNetworkLogo(((_a = V2Networks[assetItem.network]) === null || _a === void 0 ? void 0 : _a.nativeCurrency) == 'ETH' ? 1 : assetItem.network) : (assetItem === null || assetItem === void 0 ? void 0 : assetItem.contract_ticker_symbol) === 'ETH' ? getNetworkLogo(1) : ((_b = assetItem === null || assetItem === void 0 ? void 0 : assetItem.contract_ticker_symbol) === null || _b === void 0 ? void 0 : _b.includes('BTC')) || ((_c = assetItem === null || assetItem === void 0 ? void 0 : assetItem.symbol) === null || _c === void 0 ? void 0 : _c.includes('BTC')) ? '/static/perpetuals/BTC.svg' : ((_d = assetItem === null || assetItem === void 0 ? void 0 : assetItem.contract_ticker_symbol) === null || _d === void 0 ? void 0 : _d.includes('USDC')) ? '/static/tokenlogos/usdc.png' : ((_e = assetItem === null || assetItem === void 0 ? void 0 : assetItem.contract_ticker_symbol) === null || _e === void 0 ? void 0 : _e.includes('USDT')) ? '/static/perpetuals/USDT.svg' : ((_f = assetItem === null || assetItem === void 0 ? void 0 : assetItem.logo_urls) === null || _f === void 0 ? void 0 : _f.token_logo_url) ? (_g = assetItem === null || assetItem === void 0 ? void 0 : assetItem.logo_urls) === null || _g === void 0 ? void 0 : _g.token_logo_url : fallbackLogo;
};
export const getTrustWalletImage = (chain, tokenAddress) => {
  return `https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/${TRUST_WALLET_SLUGS[chain]}/assets/${ethers.utils.isAddress(tokenAddress) ? ethers.utils.getAddress(tokenAddress) : ''}/logo.png`;
};
export const getDefinedImage = (chain, tokenAddress, size = 'small') => {
  const address = isEVMNetwork(chain) ? tokenAddress === null || tokenAddress === void 0 ? void 0 : tokenAddress.toLowerCase() : tokenAddress;
  const url = `https://token-media.defined.fi/${chain}_${address}_${size}.png`;
  console.log('getDefinedImage', url);
  return url;
};
export async function getTokenImageFromAddress(chain, tokenAddress) {
  const definedUrl = getDefinedImage(chain, tokenAddress);
  try {
    const definedResponse = await fetch(`/api/proxy-image?url=${encodeURIComponent(definedUrl)}`);
    if (definedResponse.ok) {
      return definedUrl;
    }
  } catch (error) {
    console.warn('Failed to fetch Defined.fi image:', error);
  }
  const trustUrl = getTrustWalletImage(chain, tokenAddress);
  try {
    const trustResponse = await fetch(`/api/proxy-image?url=${encodeURIComponent(trustUrl)}`);
    if (trustResponse.ok) {
      return trustUrl;
    }
  } catch (error) {
    console.warn('Failed to fetch Trust Wallet image:', error);
  }
  return fallbackLogo;
}
export const getNetworkLogo = chain => {
  var _a, _b;
  try {
    if (chain == ChainId.BSC) {
      return `/static/geniusImages/network_logos/binance.png`;
    }
    return `/static/geniusImages/network_logos/${(_b = (_a = ChainId[chain]) === null || _a === void 0 ? void 0 : _a.toString()) === null || _b === void 0 ? void 0 : _b.toLowerCase()}.png`;
  } catch (e) {
    console.error('Error getting network logo for chain', chain, e);
    return '';
  }
};